import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { accountReducerKey } from './AccountConstants';
import {
  saveEmail,
  setEmail,
  init,
  resetEmail,
  setPasswordData,
  resetPassword,
  savePassword,
  trackAdobeAnalyticsEmailError,
  trackAdobeAnalyticsPasswordError,
} from './AccountActions';
import {
  isLoading as isLoadingSelector,
  email as emailSelector,
  passwordData as passwordDataSelector,
  username as usernameSelector,
  restrictedWords as restrictedWordsSelector,
  isShibboleth as isShibbolethSelector,
} from './AccountSelectors';
import AccountReducer from './AccountReducer';
import Account from './Account';

const mapStateToProps = (state) => ({
  email: emailSelector(state),
  isLoading: isLoadingSelector(state),
  passwordData: passwordDataSelector(state),
  username: usernameSelector(state),
  restrictedWords: restrictedWordsSelector(state),
  isShibboleth: isShibbolethSelector(),
});

const mapDispatchToProps = (dispatch) => ({
  saveEmail: () => dispatch(saveEmail()),
  changeEmail: (email) => dispatch(setEmail(email)),
  init: () => dispatch(init()),
  resetEmail: () => dispatch(resetEmail()),
  setPasswordData: (data) => dispatch(setPasswordData(data)),
  resetPassword: () => dispatch(resetPassword()),
  savePassword: () => dispatch(savePassword()),
  trackAdobeAnalyticsEmailError: (formErrors) => trackAdobeAnalyticsEmailError(formErrors),
  trackAdobeAnalyticsPasswordError: (formErrors) => trackAdobeAnalyticsPasswordError(formErrors),
});

export default compose(withReducer(accountReducerKey, AccountReducer), connect(mapStateToProps, mapDispatchToProps))(Account);
